function BackgroundImage() {
  return (
    <>
      <div
        style={{
          backgroundSize: "contain",
          backgroundPosition: "right bottom",
        }}
        className={`overflow-hidden absolute bottom-20 w-full h-2/5 right-20 -z-10  bg-[url(/src/assets/png/NewBgIamge.png)] bg-cover bg-no-repeat `}
      ></div>
      {/* <div
        style={{
          backgroundSize: "contain",
          backgroundPosition: "right top",
        }}
        className={`absolute top-0 right-0 -z-10 w-1/3 max-w-[50%] h-1/3 overflow-hidden`}
      ></div> */}
    </>
  );
}
export default BackgroundImage;